import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Ban } from "lucide-react";

// Blocks a community user; after blocking, their interactions are hidden server-side.
export default function BlockButton({ userId }) {
  const { t } = useLang();
  const [blocked, setBlocked] = useState(false);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    setBusy(true);
    try {
      if (blocked) {
        await api.delete(`/community/block/${userId}`);
        setBlocked(false);
      } else {
        await api.post(`/community/block/${userId}`);
        setBlocked(true);
        toast.success(t("com_blocked"));
      }
    } catch {
      toast.error(t("com_error"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button data-testid={`block-btn-${userId}`} onClick={toggle} disabled={busy}
      className="inline-flex items-center gap-1 text-xs text-stone-500 hover:text-red-400 disabled:opacity-50">
      <Ban className="w-3.5 h-3.5" /> {blocked ? t("com_blocked") : t("com_block")}
    </button>
  );
}
